module.exports = __webpack_public_path__ + "d9c57ced48b160bd283f91b1fc351f78.png";